import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Entity } from '../models';
import { EntityFormService } from './entity-form.service';

@Directive()
export abstract class EntityFormComponent<
  E extends Entity,
  F extends { [K in keyof F]: AbstractControl<any, any> } = any,
  D = any
> {
  @Input() pending: boolean;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  public get form(): FormGroup<F> {
    return this.formService.form;
  }

  protected constructor(protected formService: EntityFormService<E, F, D>) {}

  handleSubmit() {
    this.submit.emit();
  }

  handleCancel() {
    this.cancel.emit();
  }
}
